import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import OccupationalSafetyPolicy from "./index";

const occupationalSafetyRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Occupational Safety, Health & Wellbeing Policy",
		basePath: "occupational-safety-policy",
		mainComponent: <OccupationalSafetyPolicy />,
	    layout: "/console",	   
	    subTitle:"Occupational Safety, Health & Wellbeing Policy",
		level:5,
		moduleId: 0,
	})
]

export default occupationalSafetyRoutes;